/** @format */

import {divideBySpaces} from 'helpers/numberHelpers';

import {providerNewIconSrc} from 'helpers/imageHelpers';

import {Provider} from 'types';

import {ProjectTableInterface} from 'pages/HomeGrouping/types';

import {StyledTableCell} from '../StyledTableCell';
import {ProjectCell} from '../ProjectCell';
import {StyledTableBodyRow} from '../StyledTableBodyRow';

import {IconsBox} from './styles';

interface Props {
  data: ProjectTableInterface;
  onEdit: () => void;
  onProjectClick: () => void;
}

const ProjectRow = ({data, onEdit, onProjectClick}: Props) => {
  return (
    <StyledTableBodyRow onClick={onProjectClick}>
      <StyledTableCell>
        <ProjectCell data={data} onEdit={onEdit} />
      </StyledTableCell>
      <StyledTableCell>
        {data.adSystem && (
          <img
            src={providerNewIconSrc(data.adSystem as Provider, 40)}
            alt={data.adSystem}
            width={20}
            height={20}
          />
        )}
      </StyledTableCell>
      <StyledTableCell>
        <IconsBox>
          {data.analytics.map(provider => (
            <img
              key={provider}
              src={providerNewIconSrc(provider as Provider, 40)}
              alt={provider}
              width={20}
              height={20}
            />
          ))}
        </IconsBox>
      </StyledTableCell>
      <StyledTableCell>{divideBySpaces(data.triggered)}</StyledTableCell>
    </StyledTableBodyRow>
  );
};

export {ProjectRow};
